import { Component, OnInit } from '@angular/core';
import { ApiClient } from '../common/api-client.service';

interface Sheet {
  id: number;
  name: string;
}

@Component({
  templateUrl: './sheets.component.html'
})
export class SheetsComponent implements OnInit {
  sheets: Sheet[];

  constructor(
    private apiClient: ApiClient,
  ) {}

  ngOnInit() {
    this.apiClient.get<Sheet[]>('/api/v1/sheets/').toPromise().then(s => this.sheets = s);
  }

  delete(sheet: Sheet): void {
    if ( confirm('Are you sure you want to delete this transaction sheet?') ) {
      this.apiClient.delete(`/api/v1/sheets/${sheet.id}`).toPromise();
      this.sheets.splice(this.sheets.indexOf(sheet), 1);
    }
  }
}



// WEBPACK FOOTER //
// /srv/src/app/sheets/sheets.component.ts